import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarFull = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "16px",
	height: "16px",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Shape" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Wireframes-Mobile-Agent-Yulia",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Home---Messages---Star",
				transform: "translate(-275.000000, -55.000000)",
				fill: "#FBB900",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M290.940254,60.8014003 C290.837861,60.4849993 290.511485,59.9326382 289.471558,59.7814092 L285.980605,59.2698049 L284.418049,56.088634 C283.954082,55.1405035 283.331193,55 282.999483,55 C282.669906,55 282.047017,55.141576 281.58305,56.0897065 L280.019427,59.2698049 L276.528474,59.7814092 C275.487481,59.9326382 275.161105,60.4849993 275.059778,60.8014003 C274.957386,61.1167287 274.898723,61.755966 275.65067,62.4938776 L278.177424,64.9703858 L277.580133,68.4690302 C277.44361,69.2691494 277.666527,69.7367794 277.876646,69.9877551 C278.303282,70.4982869 279.070161,70.57122 279.874371,70.1443468 L282.999483,68.4936988 L286.124595,70.1454193 C286.478703,70.3331149 286.820013,70.4285714 287.134657,70.4285714 C287.532495,70.4285714 287.882337,70.2719797 288.12232,69.9877551 C288.332439,69.7367794 288.555356,69.2691494 288.417766,68.4690302 L287.821542,64.9703858 L290.348296,62.4938776 C291.101309,61.755966 291.042647,61.1167287 290.940254,60.8014003 Z",
					id: "Shape"
				})
			})
		})
	]
});
export default SvgStarFull;
